import { Route } from "react-router-dom";
import WorkerChildCareFacilities from "../components/index";
import WorkerChildCareFacilityDetails from "../components/childCare-facility-details";


const WorkerChildCareFacilitiesRoutes = () => (
  <>
    <Route path="/worker-child-care-facilities" element={<WorkerChildCareFacilities />} />
    <Route path="/worker-child-care-facility-details" element={<WorkerChildCareFacilityDetails />} />
  </>
);


export default WorkerChildCareFacilitiesRoutes;